module.exports = __webpack_public_path__ + "static/img/u163.04988a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u163.png
// module id = GLo3
// module chunks = 0